import React, { useEffect, useState } from 'react';
import { Typography, Divider, MenuItem, Grid } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import JoditTemplateEditor from '../../../Common/JodiEditor/JodiEditor';
import { EmailTemplate } from '../Model/EmailAdminModel';
import { createEmailTemplate, handleCancel } from '../Common/Common';
import { useHistory } from 'react-router-dom';
import { commonService } from '../../../Common/CommonService';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import { Loader } from '../../../../Common/Components/Loader';
import CustomButton, {
  CustomSelect,
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { useTranslation } from 'react-i18next';

const CreateTemplateOps = (props: { products: string[] }) => {
  const history = useHistory();
  const { t } = useTranslation('emailadministration');
  const [loading, setLoading] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState<EmailTemplate>({
    Name: '',
    Content: '',
    Product: '',
    Subject: '',
  });
  return (
    <>
      <Grid container spacing={3}>
        {loading ? (
          <Loader loading={loading} />
        ) : (
          <>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6">Basic Information</Typography>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Template Name </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      value={emailTemplate?.Name}
                      onChange={(e) =>
                        setEmailTemplate({
                          ...emailTemplate,
                          Name: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">E-mail Subject</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      value={emailTemplate?.Subject}
                      onChange={(e) =>
                        setEmailTemplate({
                          ...emailTemplate,
                          Subject: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Product</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={emailTemplate?.Product}
                      onChange={(e) =>
                        setEmailTemplate({
                          ...emailTemplate,
                          Product: e.target.value,
                        })
                      }
                    >
                      {props.products.map((product) => (
                        <MenuItem key={product} value={product}>
                          {product}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <CardWrapper sx={{ padding: 1 }}>
                <JoditTemplateEditor
                  emailtemplate={emailTemplate}
                  setEmailTemplate={
                    setEmailTemplate as React.Dispatch<
                      React.SetStateAction<EmailTemplate | undefined>
                    >
                  }
                />
              </CardWrapper>
            </Grid>
          </>
        )}
      </Grid>
      <FooterWrapper>
        <FooterContainer>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<Save />}
              onClick={() =>
                createEmailTemplate(
                  emailTemplate,
                  setLoading,
                  history,
                  setEmailTemplate,
                  t,
                )
              }
              label="Save"
            />
          </Grid>
          <Grid item xs={12} sm="auto">
            <CustomButton
              startIcon={<Cancel />}
              onClick={() => handleCancel(history)}
              label="Cancel"
            />
          </Grid>
        </FooterContainer>
      </FooterWrapper>
    </>
  );
};

const CreateTemplate = () => {
  const [products, setProducts] = useState<string[]>([]);

  useEffect(() => {
    loadProducts();
  }, []);
  const loadProducts = async () => {
    const products = await commonService.getProducts();
    setProducts(products.Items.map((x) => x.Id));
  };
  return (
    <div>
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Create Email Template
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <CreateTemplateOps products={products} />
      </PaperWrapper>
    </div>
  );
};

export default CreateTemplate;
